import { render } from "./PieceActions.vue?vue&type=template&id=468681dc"
import script from "./PieceActions.vue?vue&type=script&lang=js"
export * from "./PieceActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__